import { HEIMDALL_API } from ".";
import type { DataWrapper, PaginateResponse } from "./index.type";
import type {
  EnterpriseSubscriptionPlan,
  GetEnterpriseBillingInfoParams,
  PaymentCard,
  UserPaymentHistory,
} from "./payment.type";

export function addPaymentCardAPI(
  enterpriseId: number,
  customerKey: string,
  authKey: string
) {
  return HEIMDALL_API.post(
    `api/v1/allthatai/enterprise/${enterpriseId}/billing/cards/key-issue`,
    {
      json: {
        customerKey,
        authKey,
      },
    }
  ).json<DataWrapper<PaymentCard>>();
}

export function getPaymentCardListAPI(enterpriseId: number) {
  return HEIMDALL_API.get(
    `api/v1/allthatai/enterprise/${enterpriseId}/billing/cards`
  ).json<DataWrapper<PaymentCard[]>>();
}

export function deletePaymentCardAPI(
  enterpriseId: number,
  billingCardId: number
) {
  return HEIMDALL_API.delete(
    `api/v1/allthatai/enterprise/${enterpriseId}/billing/cards/${billingCardId}`
  ).json<DataWrapper<boolean>>();
}

export function setPrimaryPaymentCardAPI(
  enterpriseId: number,
  billingCardId: number
) {
  return HEIMDALL_API.patch(
    `api/v1/allthatai/enterprise/${enterpriseId}/billing/cards/${billingCardId}/set-primary`
  ).json<DataWrapper<boolean>>();
}

export function startEnterpriseBillingAPI(
  enterpriseId: number,
  billingCycle: "MONTHLY" | "YEARLY"
) {
  return HEIMDALL_API.post(
    `api/v1/allthatai/enterprise/${enterpriseId}/billing/payments`,
    {
      json: {
        billingCycle,
      },
    }
  ).json<DataWrapper<boolean>>();
}

export function getEnterpriseBillingInfoAPI(enterpriseId: number) {
  return HEIMDALL_API.get(
    `api/v1/allthatai/enterprise/${enterpriseId}/billing/subscription-plan`
  ).json<DataWrapper<EnterpriseSubscriptionPlan>>();
}

export function getEnterpriseBillingHistoryAPI(
  enterpriseId: number,
  params: GetEnterpriseBillingInfoParams
) {
  if (!!params?.page) --params.page;
  return HEIMDALL_API.get(
    `api/v1/allthatai/enterprise/${enterpriseId}/billing/payments`,
    {
      searchParams: params,
    }
  ).json<PaginateResponse<UserPaymentHistory>>();
}
